export const SortValues = ['relevance', 'recent', 'popularity'] as const;
export type Sort = (typeof SortValues)[number];
export const isSortKey = (sortString: string): sortString is Sort => {
  return ['popularity', 'recent', 'relevance'].includes(sortString);
};
export const DEFAULT_SORT: Sort = 'relevance';
